const HITL_UI_SERVICE = 'hitl';

export async function getDiscoveryUrl(serviceDiscoveryUrl: string) {
  const params = `serviceName=${HITL_UI_SERVICE}`;
  const discoveryUrl = `${serviceDiscoveryUrl}/api/v2?${params}`;
  const response = await fetch(discoveryUrl);
  const discovery = await response.json();
  return discovery.url;
}
